<template>
  <div class="q-pa-md">
    <q-btn
      flat
      class="bg-primary text-white q-mr-md"
      @click="
        recInfo ? (recordPaused ? resumeRecord() : pauseRecord()) : record()
      "
    >
      <span v-if="recInfo">
        <q-icon
          class="q-mr-sm"
          :name="`fas fa-${recordPaused ? 'pause' : 'play'}`"
          size="12px"
        />
        <span v-record-duration="recInfo.bufferDuration"></span>
      </span>
      <span v-else>开始录音</span>
    </q-btn>
    <q-btn :disable="!recInfo" outline color="red" @click="stopRecord()">
      停止录音
    </q-btn>

    <q-btn outline class="q-ml-md" v-if="voiceBlob" @click="preview">
      预览
    </q-btn>

    <q-btn
      :disable="!voiceBlob"
      outline
      color="blue"
      class="q-ml-md"
      @click="upload"
    >
      <q-icon name="fas fa-upload" size="12px" class="q-mr-sm" />
      <span>上传到OSS</span>
    </q-btn>

    <div
      class="q-mt-md bg-grey-2 rounded-borders"
      style="width: 430px;min-height: 60px"
      ref="wave"
    ></div>

    <div class="q-mt-md" v-if="voiceBlob">
      <audio controls id="record-preview"></audio>
    </div>
  </div>
</template>

<script>
import VoiceRecorderMixin from "@/mixins/voice.mixin";
import { uploadVoice } from "@/api/endpoints/voice/uploadVoice";
export default {
  mixins: [VoiceRecorderMixin],

  mounted() {},

  directives: {
    "record-duration": {
      update: (el, binding) => {
        const duration = binding.value / 1000;
        const hour = Math.floor(duration / 60 / 60);
        const minute = Math.floor((duration - hour * 60 * 60) / 60);
        const second = Math.floor(duration - hour * 60 * 60 - minute * 60);
        const f = (v) => {
          v = `${v}`;
          if (v.length < 2) v = `0${v}`;
          return v;
        };
        el.innerHTML = `${f(hour)}:${f(minute)}:${f(second)}`;
      },
    },
  },

  methods: {
    record() {
      this.requestPermission(() => {
        this.startRecord();
      });
    },

    async upload() {
      const { voiceBlob } = this;
      if (!voiceBlob) return;
      const form = new FormData();
      form.append("voice", voiceBlob, "_test_voice_record.mp3");
      await uploadVoice(form);
    },

    async preview() {
      const audio = document.getElementById("record-preview");
      if (!audio) return;
      if (audio.src) {
        (window.URL || webkitURL).revokeObjectURL(audio.src);
      }
      audio.src = (window.URL || webkitURL).createObjectURL(this.voiceBlob);
      audio.play();
    },
  },
};
</script>
